import { Link } from "react-router-dom";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import styles from "./Home.module.css";
import maggiePhoto from "../images/maggie.jpg";
import { ALL_POSTS } from "./posts/posts";
import PostRow from "../components/PostRow";

const POSTS = ALL_POSTS.filter((p) => p.featured);

export default function Home() {
  return (
    <div className={styles.page}>
      {/* ── Hero section ── */}
      <div>
        <Nav theme="light" />
        <div className={styles.hero}>
          <h1 className={styles.heroTitle}>
            Applied AI
            <br />
            Engineer &<br />
            <em>builder.</em>
          </h1>
          <p className={styles.heroSub}>
            I ship LLM features at scale and build the evals and observability
            to measure how well they work. Turns out vibes aren't a benchmark.
          </p>
          <div className={styles.heroActions}>
            <Link to="/writing" className={styles.btnPrimary}>
              read the blog →
            </Link>
            <Link to="/resume" className={styles.btnSecondary}>
              view resume
            </Link>
          </div>
        </div>
      </div>

      {/* ── Content section ── */}
      <div className={styles.lightSection}>
        <div className={styles.container}>
          {/* About section – magazine split */}
          <p className={styles.sectionLabel}>// about</p>
          <div className={styles.aboutMagazine}>
            {/* Left: narrative + highlights stacked */}
            <div className={styles.aboutLeft}>
              <div className={styles.aboutContent}>
                <h2 className={styles.cardTitle}>
                  Shipping is easy. Knowing it works is the hard part.
                </h2>
                <p className={styles.cardBody}>
                  I'm a Senior Applied AI Engineer at Zapier, building LLM
                  systems in production and focusing on making their behavior
                  measurable, debuggable, and reliable through evals,
                  observability, and real-world traces.
                </p>
                {/*<div className={styles.chips}>
                  <span className={`${styles.chip} ${styles.chipAccent}`}>
                    evals
                  </span>
                  <span className={`${styles.chip} ${styles.chipAccent}`}>
                    observability
                  </span>
                  <span className={`${styles.chip} ${styles.chipDark}`}>
                    LLM pipelines
                  </span>
                  <span className={`${styles.chip} ${styles.chipDark}`}>
                    scale
                  </span>
                  <span className={`${styles.chip} ${styles.chipLight}`}>
                    Python
                  </span>
                  <span className={`${styles.chip} ${styles.chipLight}`}>
                    React
                  </span>
                </div>*/}
              </div>
              <div className={`${styles.card} ${styles.cardMid}`}>
                <span className={styles.cardTag}>my approach</span>
                <ul className={styles.highlightList}>
                  <li className={styles.highlightItem}>
                    <span className={styles.hiNum}>01</span>
                    <div>
                      Evals-first engineering
                      <p className={styles.highlightSub}>
                        I define correctness before I build – benchmarks come
                        before features
                      </p>
                    </div>
                  </li>
                  <li className={styles.highlightItem}>
                    <span className={styles.hiNum}>02</span>
                    <div>
                      Production-scale LLM systems
                      <p className={styles.highlightSub}>
                        Real users, real traffic, messy inputs, and failure
                        modes you don’t see in demos
                      </p>
                    </div>
                  </li>
                  <li className={styles.highlightItem}>
                    <span className={styles.hiNum}>03</span>
                    <div>
                      Context is architecture
                      <p className={styles.highlightSub}>
                        How you structure context is how you structure behavior
                      </p>
                    </div>
                  </li>
                  <li className={styles.highlightItem}>
                    <span className={styles.hiNum}>04</span>
                    <div>
                      Observability as a feature
                      <p className={styles.highlightSub}>
                        Treating model decisions as observable, measurable
                        artifacts – not black boxes
                      </p>
                    </div>
                  </li>
                  <li className={styles.highlightItem}>
                    <span className={styles.hiNum}>05</span>
                    <div>
                      LLM behavior is the product
                      <p className={styles.highlightSub}>
                        Everything else is an implementation detail
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            {/* Right: full-height portrait photo */}
            <div className={styles.aboutPhoto}>
              <img src={maggiePhoto} alt="Maggie Cody" />
            </div>
          </div>

          {/* Latest writing */}
          <div className={styles.sectionHeader}>
            <p className={styles.sectionLabel}>// latest writing</p>
            <Link to="/writing" className={styles.sectionHeaderLink}>
              All writing →
            </Link>
          </div>
          <div className={styles.blogList}>
            {POSTS.map((post) => (
              <PostRow key={post.slug} post={post} variant="home" />
            ))}
          </div>

          <Footer theme="light" />
        </div>
      </div>
    </div>
  );
}
